import { Box, factory, Flex, Link, omitText, Typography } from '@kohler-dsm-library/kohler-core';
import { ArrowRightBoldIcon, ExternalLinkIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useId } from 'react';
import classes from './index.module.scss';
// import { omitTextAndTabGroup } from './OverlayMenuLinks.utils';

export const OverlayMenuLinks = factory((props, ref) => {
  const { className, title, items, CTAs, size = 'small', isCTA = false, newTabGroup = false, ...rest } = props;
  const isSmall = size === 'small';
  const titleID = useId();
  const titleElementID = `overlay-menu-title-${titleID.replace(/:/g, '')}`;

  return (
    <Flex
      ref={ref}
      direction="column"
      align="flex-start"
      className={clsx(
        className,
        'kohler-overlay-menu-links',
        classes.overlayMenuLinks,
        isSmall && !items?.length && title?.href && classes.overlayMenuLinksNoMargin
      )}
      {...rest}
    >
      {title &&
        (!isCTA ? (
          <>
            {/*eslint-disable-next-line */}
            <Typography
              component={title?.href ? 'a' : 'span'}
              className={clsx(
                classes.liVBY,
                title?.href && classes.overlayMenuCategoryLinksTitleLink,
                newTabGroup && classes.overlayMenuCategoryLinksTitleLinkCTA
              )}
              target={title?.href ? (newTabGroup ? '_blank' : undefined) : undefined}
              {...omitText(title)}
              id={titleElementID}
            >
              {title.text}
              {newTabGroup && <ExternalLinkIcon size="small" withBoundingBox={false} />}
            </Typography>
          </>
        ) : (
          <Link
            size="small"
            underline={false}
            rightIcon={<ArrowRightBoldIcon size="small" withBoundingBox={false} />}
            {...omitText(title)}
            id={titleElementID}
          >
            {title.text}
          </Link>
        ))}

      {items?.length > 0 && (
        <Flex
          component="ul"
          direction="column"
          gap={15}
          aria-labelledby={title ? titleElementID : undefined}
          className={classes.overlayMenuLinksList}
        >
          {items.map((item) => {
            if ('href' in item) {
              return (
                <Box key={item.text || item.href} component="li" className={classes.overlayMenuCategoryLinksLink}>
                  {isSmall && item.target !== '_blank' && !item.newTabGroup && (
                    <Typography
                      component="a"
                      size="navigation-overlay-item-s"
                      textColor="var(--content-action-default)"
                      // {...omitTextAndTabGroup(item)}
                        href={item.href}
                        target={item.target}
                        rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                      className={classes.overlayMenuCategoryLinksLink}
                    >
                      {item.text}
                    </Typography>
                  )}
                  {(!isSmall || item.target === '_blank' || item.newTabGroup) && (
                    <Link
                      size="medium"
                      rightIcon={undefined}
                      href={item.href}
                      target={item.target}
                      rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                      underline={false}
                      className={classes.overlayMenuCategoryLinksLinkComponent}
                    >
                      {item.text}
                    </Link>
                  )}
                </Box>
              );
            } else {
              return (
                <OverlayMenuLinks
                  component="li"
                  key={`group-${item.title?.text ?? Math.random()}`}
                  {...item}
                />
              );
            }
          })}
        </Flex>
      )}

      {CTAs && (
        <Flex
          component="ul"
          direction="column"
          gap={isSmall ? 10 : 2}
          marginTop={isSmall ? 10 : 2}
          className={classes.overlayMenuLinksList}
        >
          {CTAs.map((link) => (
            <Box key={link.href} component="li" className={classes.overlayMenuCategoryLinksCTA}>
              <Link
                size={isSmall ? 'small' : 'medium'}
                underline={false}
                rightIcon={
                  isSmall ? <ArrowRightBoldIcon size="small" withBoundingBox={false} /> : <ExternalLinkIcon withBoundingBox={false} />
                }
                {...omitText(link)}
              >
                {link.text}
              </Link>
            </Box>
          ))}
        </Flex>
      )}
    </Flex>
  );
});
